import { render } from "./newsletter-form.vue?vue&type=template&id=2c560d77"
import script from "./newsletter-form.vue?vue&type=script&lang=js"
export * from "./newsletter-form.vue?vue&type=script&lang=js"

import "./newsletter-form.vue?vue&type=style&index=0&id=2c560d77&lang=scss"

import exportComponent from "/Users/mcoombes/Dev/toteme-2023/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__